<template>
    <div class="bidding">
        <div class="opera-group">
           <a-button type="primary" @click="addItem">项目竞价</a-button>
        </div>  
         <div class="manage-table">
            <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" :scroll="{ x: 1300 }"   :rowKey="(record,index)=>{return index}" >
                <span slot="biddingPrice" slot-scope="text">{{ text }}万元</span>
                <span slot="projectCode" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text }}</span>
                      </template>
                      {{ text }}
                  </a-tooltip> 
                </span>
                <span slot="projectName" slot-scope="text">
                  <a-tooltip placement="topLeft">
                      <template slot="title">
                        <span> {{ text }}</span>
                      </template>
                      {{ text }}
                  </a-tooltip> 
                </span>
                <template slot="action" slot-scope="text,record">
                  <div class="operate-btns">
                     <a-button type="primary" @click="forDetail(record)">查看详情</a-button>
                     <a-upload class="upload-demo"
                           action="#" :customRequest="customRequest" :show-upload-list="false"
                           @click.native = getRow(record)
                           >
                        <a-button type="primary" :disabled="record.ensureUrl?true:false || record.listedType=='01'?true:false">上传流转保证金凭证</a-button>
                     </a-upload>
                     <a-button type="primary" :disabled="record.auditState=='1'?true:false" @click="calcel(record)">取消</a-button>
                  </div>
                </template>
            </a-table>    
         </div>     
        <main-dialog ref="mainDialog" @getDataList="getDataList"></main-dialog>
        <maindetails ref="maindetails"></maindetails>
        <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
    </div>    
</template>
<script>
import mainDialog from './dialog.vue'
import maindetails from './bidDetails.vue'
const columns = [
   {
      title: '项目编码',
      dataIndex: 'projectCode',
      width: 100,
      scopedSlots: { customRender: 'projectCode' },
   },
   {
      title: '项目名称',
      dataIndex: 'projectName',
      width: 100,
      scopedSlots: { customRender: 'projectName' },
   },
   {
      title: '起拍价',
      dataIndex: 'biddingPrice',
      width: 100,
      scopedSlots: { customRender: 'biddingPrice' },
   },
   {
      title: '挂牌类型',
      dataIndex: 'listedTypeName',
      width: 100,
      scopedSlots: { customRender: 'listedTypeName' },
   },
   {
      title: '竞拍状态',
      dataIndex: 'biddingStateName',
      width: 100,
      scopedSlots: { customRender: 'biddingStateName' },
   },
   {
      title: '挂单状态',
      dataIndex: 'listedStateName',
      width: 100,
      scopedSlots: { customRender: 'listedStateName' },
   },
   {
      title: '审核状态',
      dataIndex: 'auditStateName',
      width: 100,
      scopedSlots: { customRender: 'auditStateName' },
   },
   {
      title: '委托时间',
      dataIndex: 'createTime',
      width: 150
   },
   {
      title: '操作',
      fixed: 'right',
      id:'8',
      dataIndex: 'operate',
      width: 360,
      scopedSlots: { customRender: 'action' },
   },
];
export default {
    components:{
        mainDialog,
        maindetails
    },
    data(){
        return{
            columns:columns,
            data:[],
            projectDict:[
               {
                   bg_project_category:[]
               }
            ],
            total:1,
            params:{
              pageSize:10,
              pageNum:1
            },
            loading:false,
            currentId:'',
        }
    },
    created(){
        this.$parent.activeIndex = 3;
        this.getDataList();
    },
    methods:{
        addItem(){
           this.$refs.mainDialog.showDiolag();
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getDataPage(){
            this.params.pageNum = 1;
            this.getDataList();
        },
        getRow(row){
           this.currentId = row.id;
           console.log(this.currentId)
        },
        customRequest(info){
           let formdata=new FormData();
            formdata.append("file",info.file);
            this.$https.post('/file/upload',formdata).then(res=>{
               if(res.code == 200){
                  this.uploadNote(res.data.url)
               }
            }).catch(error=>{
               this.$error({content:'上传失败'});
            })
        },
        uploadNote(url){
            this.$https.post('/portal/bidding/uploadEnsure',{ensureUrl:url,id:this.currentId}).then(res=>{
                   if(res.code == 200){
                      this.$message.success('上传成功');
                      this.getDataPage();
                   }
            })
        },
        getDataList(){
            this.loading = true;
            this.$https.get('/portal/bidding/list',{params:this.params}).then(res=>{
               this.loading = false;
               if(res.code == 200){
                  this.data = res.rows;
                  this.total = Number(res.total);
               }
            }).catch(error=>{
                this.loading = false;
            })
        },
        forDetail(row){
             row = JSON.stringify(row)
             this.$refs.maindetails.showDiolag(row,2);
        },
        calcel(row){
         let _this = this;
         this.$confirm({
               title: '确定取消该项目竞价?',
               content: '',
               onOk() {
                  _this.$https.get(`/portal/bidding/cancel/${row.id}`).then(res=>{
                        if(res.code == 200){
                           _this.$message.success('取消成功');
                           _this.getDataPage();
                        }
                  }).catch(error=>{
                           _this.$message.success('取消失败');
                  })
               },
               onCancel() {},
               });
        }
    }

}
</script>

<style lang="less" scoped>
.opera-group{
   margin:0 0 20px 20px;
}
.operate-btns{
   display: flex;
   .ant-btn{
      margin-right:8px;
   }
}
</style>